<template>
  <el-input :value="defineValue" :placeholder="placeholder" :type="type" :maxlength="maxlength" :minlength="minlength"
    :disabled="disabled" @input="changeValue" @change="$emit('change',defineValue)"/>
</template>

<script>
  export default {
    props: {
      placeholder: {
        type: String,
        required: false,
      },
      type: {
        type: String,
        required: false,
        default: () => {
          return 'input'
        }
      },
      maxlength: {
        type: [String, Number],
        required: false,
      },
      minlength: {
        type: [String, Number],
        required: false,
      },
      disabled: {
        type: Boolean,
        required: false,
      },
      // value 有可能是 undefined unll 不定义type
      value: {
        required: true,
      }
    },
    data() {
      return {
        defineValue: this.value,
      }
    },
    methods: {
      changeValue(e) {
        this.defineValue = e
        this.$emit('input', e)
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ABinput.vue